export const TABLE_HEAD: {
  id: string;
  label: string;
  align?: 'left' | 'center' | 'right';
}[] = [
  { id: 'userId', label: 'User Id' },
  { id: 'ssoUserId', label: 'SSO Id' },
  { id: 'username', label: 'Username' },
  { id: 'isAlive', label: 'Alive' },
  { id: 'isBackIn', label: 'Back In' },
  { id: 'actions', label: '', align: 'right' },
];

export const FUTURE_USERS_TABLE_HEAD: {
  id: string;
  label: string;
  align?: 'left' | 'center' | 'right';
}[] = [{ id: 'ssoUserId', label: 'SSO Id' }];

export function descendingComparator(a: any, b: any, orderBy: any) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order: string, orderBy: string) {
  return order === 'desc'
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

export function applySortFilter(array: any[], comparator: any, query: any) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return array.filter(
      (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}
